

<template>
  <GravManagerWrapper :id="id" :componentName="componentName" :properties="props">
    <component :is="DownlineTable" v-bind="{ style: $attrs.style, ...changableProps }">
      <template v-for="slotName in Object.keys($slots)" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </component>
  </GravManagerWrapper>
</template>

<script setup lang="ts">
import { DownlineTableProps } from './DownlineTable.ts';
import DownlineTable from './DownlineTable.vue';
import GravManagerWrapper from './GravManagerWrapper.vue';

import { useChangableProps } from '@/composables/useChangableProps';

const componentName = 'ui-downline-table';
const $slots = defineSlots<Record<string, unknown>>();

const props = defineProps<DownlineTableProps>();
const changableProps = useChangableProps(componentName, props);

</script>
